import React from "react";
import { Component } from "react";
import Home from "./Components/Home";
import About from "./Components/About";
import Services from "./Components/Services";
import Projects from "./Components/Projects";
import Contact from "./Components/Contact";

import './App.css';


class App extends Component {

    constructor(){
        super()
        
      this.state = {
        page:Home
      }
    }
   
    viewRender = (page) => {
      this.setState({page: page})
    }

    render(){
      return(
      <div className="origin">
      <nav className='navbar-main'>
        <p onClick={()=>{this.viewRender(Home)}}>Home</p>
        <p onClick={()=>{this.viewRender(About)}}>About me</p>
        <p onClick={()=>{this.viewRender(Services)}}>Services</p>
        <p onClick={()=>{this.viewRender(Projects)}}>Projects and presentations</p>
        <p onClick={()=>{this.viewRender(Contact)}} className='contact'>Contact</p>
      </nav>

      <this.state.page/>
      <div className="bottom">

      </div>
      
    </div>
      )
        
    }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js